<template>
  <div class="data-science-cards" :class="[options.dark ? 'dark' : '']">
    <div class="container">
      <div class="heading col-8">
        <h2 class="h2">
          {{ options.title }}
        </h2>
        <span>
          {{ options.subtitle }}
        </span>
      </div>
      <div class="cards row">
        <div v-if="options.firstCardTitle" class="col col-4">
          <div class="card">
            <slot name="card1-icon" />
            <IconBriefcase v-if="!$slots['card1-icon']" class="icon-briefcase" />
            <h3 class="h4">
              {{ options.firstCardTitle }}
            </h3>
            <span>
              {{ options.firstCardText }}
            </span>
          </div>
        </div>
        <div v-if="options.secondCardTitle" class="col col-4">
          <div class="card">
            <slot name="card2-icon" />
            <IconSkills v-if="!$slots['card2-icon']" class="icon-monitor" />
            <h3 class="h4">
              {{ options.secondCardTitle }}
            </h3>
            <span>
              {{ options.secondCardText }}
            </span>
          </div>
        </div>
        <div v-if="options.thirdCardTitle" class="col col-4">
          <div class="card">
            <slot name="card3-icon" />
            <IconPeople v-if="!$slots['card3-icon'] && $config.platform === 'ds'" class="icon-people" />
            <IconUsers v-if="!$slots['card3-icon'] && $config.platform === 'fa'" class="icon-users" />
            <h3 class="h4">
              {{ options.thirdCardTitle }}
            </h3>
            <span>
              {{ options.thirdCardText }}
            </span>
          </div>
        </div>
        <div v-if="options.fourthCardTitle" class="col col-4">
          <div class="card">
            <IconValidate class="icon-validate" />
            <h3 class="h4">
              {{ options.fourthCardTitle }}
            </h3>
            <span>
              {{ options.fourthCardText }}
            </span>
          </div>
        </div>
        <div v-if="options.fifthCardTitle" class="col col-4">
          <div class="card">
            <IconMedal class="icon-medal" />
            <h3 class="h4">
              {{ options.fifthCardTitle }}
            </h3>
            <span>
              {{ options.fifthCardText }}
            </span>
          </div>
        </div>
        <div v-if="options.sixthCardTitle" class="col col-4">
          <div class="card">
            <IconUsers class="icon-users" />
            <h3 class="h4">
              {{ options.sixthCardTitle }}
            </h3>
            <span>
              {{ options.sixthCardText }}
            </span>
          </div>
        </div>
      </div>
      <button
        v-if="buttonText" class="btn-primary" data-direct-send
        :data-event="`${$route.path.replace(/\//g, '')}_goals.click`"
        @click.prevent="$emit('scrollToLastSection')"
      >
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
import IconBriefcase from '../../assets/svg/icon-landing-briefcase.svg?vue-components';
import IconSkills from '../../assets/svg/icon-landing-skills.svg?vue-components';
import IconPeople from '../../assets/svg/icon-landing-people.svg?vue-components';
import IconValidate from '../../assets/svg/icon-landing-validate.svg?vue-components';
import IconMedal from '../../assets/svg/icon-landing-medal.svg?vue-components';
import IconUsers from '../../assets/svg/icon-landing-users.svg?vue-components';

export default {
  components: {
    IconBriefcase,
    IconSkills,
    IconPeople,
    IconValidate,
    IconMedal,
    IconUsers,
  },
  props: {
    options: { type: Object, default: () => {}, required: true },
    buttonText: { type: String, default: '', required: false },
  },
};
</script>

<style lang="scss" scoped>
.data-science-cards {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &.dark {
    .heading {
      color: var(--main-light);

      span {
        color: var(--main-dark-shade-4);
        line-height: 150%;
      }
    }

    .cards .card {
      background-color: var(--main-dark-light-2);
      color: var(--main-light);

      span {
        color: var(--main-light-shade-4);
      }
    }
  }

  &:not(.dark) .cards .card svg path[stroke="#fff"] {
    stroke: var(--main-dark);
  }

  .heading {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;

    span {
      text-align: center;
    }
  }

  .cards {
    display: flex;
    margin-top: 18px;
    margin-bottom: var(--spacing-48);

    &.cards .col-4 {
      align-items: stretch;
      display: flex;
    }

    .card {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      background: var(--main-light);
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
      border-radius: 7px;
      width: 100%;
      padding: var(--spacing-48) var(--spacing-48) 75px var(--spacing-48);
      text-align: center;
      margin-top: 30px;

      svg {
        width: 64px;
        height: 64px;
        margin-bottom: var(--spacing-36);
      }

      .h4 {
        margin-bottom: var(--spacing-8);
      }

      span {
        color: var(--main-dark-shade-3);
      }
    }
  }

  .btn-primary {
    width: 350px;
    height: 65px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
  }

  @include bp($bp-laptop) {
    .heading span {
      padding: 0;
    }

    .btn-primary {
      width: 310px;
    }
  }

  @include bp($bp-mobile) {
    .heading {
      text-align: center;

      .h2 {
        font-size: 28px;
      }

      span {
        max-width: 100%;
        color: var(--main-light-shade-4);
        padding: 0;
      }
    }

    .cards {
      flex-direction: column;
    }
  }

  @include bp($bp-phone) {
    .btn-primary {
      width: 100%;
      height: 63px;
    }
  }
}
</style>
